(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-product-tabs"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const tabTitles = document.querySelectorAll('.tab-title');
    const tabContents = document.querySelectorAll('.tab-content');

    if (tabTitles.length && tabContents.length && tabTitles.length === tabContents.length) {
      tabTitles.forEach((title, i) => {
        title.addEventListener('click', function (e) {
          e.preventDefault();
          if (title.classList.contains('is-active')) return;
          tabTitles.forEach(t => t.classList.remove('is-active'));
          tabContents.forEach(c => c.classList.remove('is-active'));
          title.classList.add('is-active');
          setTimeout(() => {
            const content = tabContents[i];
            content.classList.add('is-animating');
            content.classList.add('is-active');
            content.addEventListener('transitionend', function handler() {
              content.classList.remove('is-animating');
              content.removeEventListener('transitionend', handler);
            });
          }, 10);
        });
      });
    }

    const toggleLinks = document.querySelectorAll('.toggle-link');

    toggleLinks.forEach(toggleLink => {
      toggleLink.addEventListener('click', function(e) {
        e.preventDefault();

        const toggleTitle = toggleLink.closest('.toggle-title');
        if (!toggleTitle) return;

        const tabTitleText = document.querySelector('.tab-title-text');
        if (tabTitleText) {
          tabTitleText.textContent = toggleLink.textContent;
        }

        const viewContentType = toggleTitle.dataset.viewContent;
        const content = toggleTitle.nextElementSibling;
        if (!content) return;

        switch (viewContentType) {
          case 'sidebar': {
            const drawerContent = document.querySelector('.drawer-content-wrapper');
            if (drawerContent) {
              drawerContent.innerHTML = '';
              drawerContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          case 'popup': {
            const popupContent = document.querySelector('.popup-content-wrapper');
            if (popupContent) {
              popupContent.innerHTML = '';
              popupContent.appendChild(content.cloneNode(true));
              renderVideo();
            }
            break;
          }
          default:
            toggleTitle.classList.toggle('is-open');
        }
      });
    });
    const modalTemplate = `
      <side-drawer
        class="popup__content video-modal drawer fixed top-0 left-0 z-9 w-screen h-full flex justify-center no-js-hidden"
        element-s-popup=""
        id="PopupModal-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
        data-moved="true"
      >
        <div
          id="Drawer-Overlay-AZDFEMWdKNDFCVHdoM__popup_link_desc_video"
          class="drawer__overlay fixed inset-0 cursor-pointer"
          style="transform: translateX(0px)"
        ></div>
        <div
          class="popup__inner color-scheme-1 popup__inner--video w-auto h-full absolute-c-c flex flex-column global-settings-popup"
        >
          <div
            class="popup__inner--content relative w-full h-full overflow-auto cus-scrollbar"
          >
            <div class="video-modal__content-block">Video</div>
            <button
              onclick="this.closest('side-drawer').close()"
              class="button button-unstyled close-button popup__close minimum-touch-target-before drawer__close block t-button bor-none rounded-full cursor-pointer absolute"
              type="button"
              aria-label="Close dialog"
              style="--top: 0.3rem; --right: 0.3rem"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                class="icon icon-close"
                viewBox="0 0 18 17"
              >
                <path
                  fill="currentColor"
                  d="M.865 15.978a.5.5 0 0 0 .707.707l7.433-7.431 7.579 7.282a.501.501 0 0 0 .846-.37.5.5 0 0 0-.153-.351L9.712 8.546l7.417-7.416a.5.5 0 1 0-.707-.708L8.991 7.853 1.413.573a.5.5 0 1 0-.693.72l7.563 7.268z"
                ></path>
              </svg>
            </button>
          </div>
        </div>
      </side-drawer>
    `;
    document.body.insertAdjacentHTML('beforeend', modalTemplate);

    function renderVideo() {
      const videoOpenPopups = document.querySelectorAll('.video-open-popup');
    
      if (videoOpenPopups.length > 0) {
        videoOpenPopups.forEach(videoOpenPopup => {
          videoOpenPopup.addEventListener('click', function(e) {
            e.preventDefault();

            const videoId = videoOpenPopup.dataset.videoId;
            const videoWrapper = document.querySelector('.video-modal__content-block');

            const youtubeIframe = `
            <iframe width="100%" src="https://www.youtube.com/embed/${videoId}?si=6yJ56P_BJEG5d2Uq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            `;

            videoWrapper.innerHTML = youtubeIframe;
          });
        });
      }
    }
    renderVideo();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-product-carousel"] && !Shopify.designMode) return;
  try {
    
  const initializeVideoProductCarousel = (section) => {
    if (section.dataset.carouselReady === 'true') return;
    section.dataset.carouselReady = 'true';

    const track = section.querySelector('[data-carousel-track]');
    const previous = section.querySelector('[data-carousel-previous]');
    const next = section.querySelector('[data-carousel-next]');
    const dialog = section.querySelector('[data-video-dialog]');
    const dialogMedia = section.querySelector('[data-video-dialog-media]');
    const dialogClose = section.querySelector('[data-video-dialog-close]');
    const dialogForm = section.querySelector('[data-video-dialog-form]');
    const dialogVariant = section.querySelector('[data-video-dialog-variant]');
    const dialogProduct = section.querySelector('[data-video-dialog-product]');
    const dialogCart = section.querySelector('[data-video-dialog-cart]');
    const dialogStatus = section.querySelector('[data-video-dialog-status]');
    if (!track) return;
    const cards = Array.from(track.querySelectorAll('.video-product-carousel__card'));
    const autoScroll = section.dataset.autoScroll === 'true';
    const autoScrollDelay = Number(section.dataset.autoScrollSeconds) * 1000;
    let scrollTimer;
    const playAllVideos = () => {
      const videos = cards.map((card) => card.querySelector('video')).filter(Boolean);
      videos.forEach((video) => {
        video.muted = true;
        video.play().catch(() => {});
      });
    };

    const closeDialog = () => {
      if (!dialog?.open) return;
      dialog.close();
    };

    const openDialog = (card, sourceVideo) => {
      if (!dialog || !dialogMedia || !dialogVariant || !dialogProduct || !dialogCart) return;
      const fullscreenVideo = sourceVideo.cloneNode(true);
      fullscreenVideo.controls = false;
      fullscreenVideo.autoplay = true;
      fullscreenVideo.removeAttribute('muted');
      fullscreenVideo.muted = false;
      fullscreenVideo.volume = 1;
      fullscreenVideo.loop = true;
      dialogMedia.replaceChildren(fullscreenVideo);
      dialogVariant.value = card.dataset.variantId || '';
      dialogProduct.textContent = card.dataset.productTitle || '';
      dialogCart.disabled = card.dataset.variantAvailable !== 'true';
      dialogCart.textContent = dialogCart.disabled ? 'Sold out' : 'Add to cart';
      dialogStatus.textContent = '';
      cards.forEach((carouselCard) => carouselCard.querySelector('video')?.pause());
      dialog.showModal();
      fullscreenVideo.play().catch(() => {});
    };

    const move = (direction) => {
      const card = track.querySelector('.video-product-carousel__card');
      if (!card) return;
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      const step = card.getBoundingClientRect().width + gap;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      const atStart = track.scrollLeft <= 2;

      if (direction > 0 && atEnd) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else if (direction < 0 && atStart) {
        track.scrollTo({ left: track.scrollWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: direction * step, behavior: 'smooth' });
      }
    };

    const startAutoScroll = () => {
      window.clearInterval(scrollTimer);
      if (autoScroll && autoScrollDelay > 0 && cards.length > 1) {
        scrollTimer = window.setInterval(() => move(1), autoScrollDelay);
      }
    };

    previous?.addEventListener('click', () => {
      move(-1);
      startAutoScroll();
    });
    next?.addEventListener('click', () => {
      move(1);
      startAutoScroll();
    });
    track.addEventListener('pointerdown', startAutoScroll, { passive: true });

    cards.forEach((card) => {
      const video = card.querySelector('.video-product-carousel__media > video');
      video?.addEventListener('click', () => openDialog(card, video));
    });

    dialogClose?.addEventListener('click', closeDialog);
    dialog?.addEventListener('cancel', (event) => {
      event.preventDefault();
      closeDialog();
    });
    dialog?.addEventListener('close', () => {
      dialogMedia?.replaceChildren();
      playAllVideos();
    });

    dialogForm?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!dialogCart || dialogCart.disabled) return;
      dialogCart.disabled = true;
      dialogCart.textContent = 'Adding…';
      dialogStatus.textContent = '';

      try {
        const response = await fetch(dialogForm.dataset.cartAddUrl, {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(dialogForm)
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result.description || 'Unable to add this product.');
        dialogCart.textContent = 'Added to cart';
        dialogStatus.textContent = 'Product added successfully.';
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: result }));
      } catch (error) {
        dialogCart.disabled = false;
        dialogCart.textContent = 'Add to cart';
        dialogStatus.textContent = error.message;
      }
    });

    playAllVideos();
    startAutoScroll();
  };

  document.querySelectorAll('.video-product-carousel').forEach(initializeVideoProductCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('.video-product-carousel');
    if (section) initializeVideoProductCarousel(section);
  });

  } catch(e) { console.error(e); }
})();
})();
